<template>
    <div id="learn-one" >
      <div class="learn-one-desktop" v-if="$vuetify.breakpoint.smAndUp" :class="{lg:$vuetify.breakpoint.lg, md:$vuetify.breakpoint.md, sm:$vuetify.breakpoint.sm}">
        <div class="background-learn background-steps z-index-10"></div>
        <div class="learn-block d-flex flex absolute information z-index-10">
            <img class="decor-two mr-8" src="@/assets/images/learn/robot.png">
            <div class="text">
                <div class="roboto-bold-48 clr-black">Отлично!</div>
                <div class="roboto-normal-24 text-info clr-black mt-xl-10 mt-lg-10 mt-md-4 mt-sm-4">Теперь нужно создать подраздел, например “{{sampleName}}”.</div>
                <LearnSkipButton class="mt-4 mt-lg-8"/>
            </div>
        </div>
        <Arrow 
            class="arrow-learn-1 absolute z-index-10"
            :style="buttonAddPos" 
            width="150" 
            height="200" 
            max-width="150"
            :start="'M3 30'"
            :curvature="'Q 100 100'"
            :end="'130 250'"
            :points="'13 64 2 29 37 35'"
        />
      </div>
      <div class="learn-one-mobile" v-else>
        <div class="background-learn background-steps z-index-10"></div>
        <img class="absolute decor-one z-index-10" src="@/assets/images/learn/robot_mobile.png">
        <div class="learn-block-mobile absolute z-index-10">
            <div class="text z-index-10 roboto-normal-18 clr-black-38 mt-4">Теперь нужно создать подраздел, например “{{sampleName}}”.</div>
            <LearnSkipButton class="mt-4 mt-lg-8"/>
        </div>
        <Arrow 
          v-if="$vuetify.breakpoint.xs"
          class="arrow-mobile absolute z-index-10" 
          width="170" 
          height="170" 
          max-width="170"
          :start="'M10 40'"
          :curvature="'Q 90 70'"
          :end="'130 150'"
          :points="'20 65 10 40 42 35'"
        />
      </div>
      <img :style="buttonAddPos" class="ml-3 button-add absolute z-index-100 pointer" height="33.91px" @click="addTask()" src="@/assets/images/components/button-add-blue.png" :class="{xs:$vuetify.breakpoint.xs}">
      <img :style="buttonAddPos" class="button-add-ellipse absolute z-index-10" src="@/assets/images/learn/Ellipse 95.png" :class="{xs:$vuetify.breakpoint.xs}">
    </div>
</template>

<script lang='ts'>
    import { Vue } from 'vue-property-decorator'
    import { PropType } from 'vue'
    import Arrow from './../../misc/Arrow.vue'
    import { mapGetters } from 'vuex'
    import LearnSkipButton from './LearnSkipButton.vue'

    export default Vue.extend({
        props: {
            // item: Object as PropType<Block>,
            sampleName: String
        },
        components: {
            LearnSkipButton,
            Arrow,
        
        },
        data() {
            return {
                buttonAddPos: {left: '', top: ''},
                
            }
        },
        computed: {
            ...mapGetters(['themes']),
        },
        methods: {
            addTask() {
                this.$root.$emit('addTask')
            },
            updatePlusPosition() {
                const el = document.querySelector('.add-task img')
                const buttonAddRect = el && el.getBoundingClientRect()
                if (buttonAddRect) {                
                    this.buttonAddPos.left = Math.floor(buttonAddRect.left) + 'px'
                    this.buttonAddPos.top = Math.floor(buttonAddRect.top) + 'px'
                }
            }
        },
        mounted() {
            // this.$nextTick(this.updatePlusPosition)
            // setInterval(() => {

            // })
        }
    })

    </script>

<style lang="scss" scoped>
    #learn-one {
        .learn-one-desktop {
            .learn-block{
                background: url('~@/assets/images/learn/Ellipse 88.png') no-repeat center;
                background-size: contain;
                width: 55%;
                padding: 80px 100px 100px 50px;
            }
            .decor-one {
                top:350px;
                left:35%;
            }
            .information {
                top:333px;
                left:35%;
                .decor-two {
                    left:35px;
                }
                .text {
                    top:35px;
                    left:340px;
                    width:385px;
                }
            }
            &.lg {
                .decor-one {
                    left:29%;
                }
                .information{
                    left:10%;
                }
                .decor-two {
                    top:-20px;
                    left:-10px;
                    height:178px;
                }
            }
            &.md {
                .learn-block{
                    padding: 80px 50px 40px 50px;
                }
                .decor-one {
                    left:13%;
                }
                .information{
                    left:13%;
                    .text-info{
                        font-size: 20px;
                    }
                }
                .decor-two {
                    top:-20px;
                    left:-10px;
                    height:178px;
                }
            }
            &.sm {
                .learn-block{
                    width: 500px;
                    padding: 80px 30px 100px 20px;
                }
                .decor-one {
                    left:0%;
                    width:590px;
                }
                .information{
                    left:5%;
                    .text{
                        top:-10px;
                        left:220px;
                        width:300px;
                    }
                    .text-info{
                        font-size: 20px;
                    }
                }
                .decor-two {
                    top:-20px;
                    left:-10px;
                    height:178px;
                }
            }
        }
        .learn-one-mobile {
            .learn-block-mobile{
                background: url('~@/assets/images/learn/Ellipse 114.png') no-repeat center;
                background-size: 72%;
                width: 420px;
                max-width: 100vw;
                padding: 40px 45px 40px 105px;
            }
            .decor-one {
                top:329px;
                left:32%;
            }
            .decor-two {
                top:490px;
                left:-7%;
            }
            .learn-block-mobile {
                top: 560px;
                left: 0px;
                height: 190px;
            }
            .arrow-mobile {
                top: 170px;
                left: 15%;
            }
        }
        .button-add-ellipse {
            margin-left: -20px;
            margin-top: -33px;
            height: 100px;
            width: 100px;
        }
        .arrow-learn-1 {
            margin-left: 50px;
            margin-top: 33px;
        }
    }
</style>
